/**
 * Copyright (c) 2023-present,
 * Eunoia Digital, S.L. All rights reserved.
 */

import { AxiosError, AxiosResponse } from 'axios';
import configuration from 'config';
import { PerfilConsumoResponse } from 'types/interfaces/idPerfilConsumo';
import PerfilConsumo, { PerfilConsumoCaracteristica } from 'types/models/PerfilConsumo';
import apiService from './ApiService';

export interface PromotorDto {
  id: number;
  nombre: string;
  descripcion: string;
  curva_de_consumo: {
    año: string;
    consumo: number;
  };
  caracteristicas: Array<PerfilConsumoCaracteristica>;
}
export interface PostPerfilDeConsumo {
  nombre: string;
  descripcion: string;
}
export class MatcherPerfilesConsumoService {
  private readonly http = apiService;

  private apiUrl = configuration.apiUrl;

  public async getAllPerfilesDeConsumo(): Promise<Array<PerfilConsumo>> {
    const url = `${this.apiUrl}/matcher/perfil-de-consumo/`;

    const response: AxiosResponse = await this.http.get(url);
    const perfiles = new PerfilConsumo().deserializeArray(response.data.datos);
    return perfiles;
  }

  public async getPerfilesDeConsumoById(id: Number): Promise<PerfilConsumo> {
    const url = `${this.apiUrl}/matcher/perfil-de-consumo/${id}`;

    const response: AxiosResponse = await this.http.get(url);
    return new PerfilConsumo().deserialize(response.data.datos);
  }

  async postPerfilDeConsumo(perfilDeConsumoActualizacion: PostPerfilDeConsumo): Promise<PerfilConsumoResponse> {
    const url = `${this.apiUrl}/matcher/perfil-de-consumo/`;

    const response: AxiosResponse<PerfilConsumoResponse> = await this.http.post(url, perfilDeConsumoActualizacion);

    return response.data;
  }

  async patchPerfilDeConsumoActualizacion(
    id: string,
    perfilDeConsumoActualizacion: PostPerfilDeConsumo,
  ): Promise<string> {
    const url = `${this.apiUrl}/matcher/perfil-de-consumo/${id}/`;

    const response: AxiosResponse<string> = await this.http.patch(url, perfilDeConsumoActualizacion);

    return response.data;
  }

  async deletePerfilDeConsumo(id: number): Promise<unknown> {
    const url = `${this.apiUrl}/matcher/perfil-de-consumo/${id}`;

    const response: AxiosResponse<number> = await this.http.delete(url);

    return response;
  }

  // TODO
  async patchPerfilDeConsumoCSV(id: number, file: File): Promise<any> {
    const url = `${this.apiUrl}/matcher/perfil-de-consumo/${id}/curva-consumo/`;
    const csvData = new window.FormData();
    csvData.append('curvaDeConsumo', file);

    let responsePromise;
    try {
      const response: AxiosResponse = await this.http.patch(url, csvData);
      responsePromise = response.status;
    } catch (error: unknown) {
      if ((error as AxiosError)?.response?.data && (error as AxiosError).response?.status === 400) {
        responsePromise = {
          codigo: (error as AxiosError).response?.data[0].codigo,
          mensaje: (error as AxiosError).response?.data[0].mensaje,
        };
      }
    }
    return responsePromise;
  }

  // Devuelve un CSV (representado por Blob en JavaScript)
  public async descargarInforme(id: number): Promise<Blob> {
    const url = `${this.apiUrl}/matcher/perfil-de-consumo/${id}/curva-consumo/`;
    const response: AxiosResponse<Blob> = await this.http.get(url);

    return response.data;
  }
}

const MatcherPerfilesConsumoInstance = new MatcherPerfilesConsumoService();
export default MatcherPerfilesConsumoInstance;
